export default {
  enableTime: true,
  enableSeconds:true,
  maxDate: 'today',
  time_24hr: true,
  dateFormat: 'Y-m-d H:i:S',
  onChange: function(rawdate, altdate, FPOBJ) {
    FPOBJ.close(); // Close datepicker on date select
    FPOBJ._input.blur(); // Blur input field on date select
  }
}